import {Box} from '@mui/material'
import React from 'react'
import 'swiper/css';
import TopSellers from './TopSellers';
import Intro from './Intro';
import TrendingEarpone from './TrendingEarpone';
import Gaming from './Gaming';
import BoatBlogs from './BoatBlogs';
import UserReview from './UserReview';
import Achivement from './Achivement';
import Footer from './Footer';

const Home = () => {
  return (
    <Box sx={{paddingTop:{xs: '8rem', sm: '8rem', md:'4rem',lg: '4rem'}, background: 'black'}}>
        <Intro />
        <TopSellers />
        <TrendingEarpone />
        <Gaming />
        <BoatBlogs />
        <UserReview />
        <Achivement />
        <Footer />
    </Box>
  )
}

export default Home